import { render, staticRenderFns } from "./NotificarPagamento.vue?vue&type=template&id=0eb188ac&scoped=true&"
import script from "./NotificarPagamento.vue?vue&type=script&lang=js&"
export * from "./NotificarPagamento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0eb188ac",
  null
  
)

export default component.exports